function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { useTranslation } from 'react-i18next';
import IconGear from '~icons/bi/gear';
import { Menu, MenuButton, MenuLink, useCallout } from '@arc/frontend/ui-common';
import { useAbility } from '@arc/frontend/util-auth';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "18mxbui",
  styles: "width:1em;height:1em"
} : {
  name: "1yee8se-GearMenu",
  styles: "width:1em;height:1em;label:GearMenu;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export function GearMenu({
  iconButtonStyle
}) {
  const {
    t
  } = useTranslation('common');
  const {
    ability,
    missingPermissionText
  } = useAbility();
  const {
    callout: missingListRolesPermCallout,
    setShowViewCallout: showNoListRolesPermCallout
  } = useCallout({
    text: missingPermissionText('list', 'Role')
  });
  const {
    callout: missingListUsersPermCallout,
    setShowViewCallout: showNoListUsersPermCallout
  } = useCallout({
    text: missingPermissionText('list', 'User')
  });
  const {
    callout: missingListDeployGroupsPermCallout,
    setShowViewCallout: showNoListDeployGroupsPermCallout
  } = useCallout({
    text: missingPermissionText('list', 'Deployment/Group')
  });
  const {
    callout: missingListMembersPermCallout,
    setShowViewCallout: showNoListMembersPermCallout
  } = useCallout({
    text: missingPermissionText('list', 'Member')
  });
  const {
    callout: missingListDeployPipelinesPermCallout,
    setShowViewCallout: showNoListDeployPipelinesPermCallout
  } = useCallout({
    text: missingPermissionText('list', 'Deployment/Pipeline')
  });
  const {
    callout: missingListOnCallSchedulePermCallout,
    setShowViewCallout: showNoListOnCallSchedulePermCallout
  } = useCallout({
    text: missingPermissionText('list', 'OnCallSchedule')
  });
  return <>
			<Menu trigger={<MenuButton css={iconButtonStyle} data-testid="gear-menu">
						<IconGear css={_ref} />
					</MenuButton>}>
				<MenuLink to="/users" disabled={ability.cannot('list', 'User')} onDisabledClick={showNoListUsersPermCallout} data-testid="gear-menu-users">
					{t('sections.users')}
				</MenuLink>
				<MenuLink to="/roles" disabled={ability.cannot('list', 'Role')} onDisabledClick={showNoListRolesPermCallout}>
					{t('sections.roles')}
				</MenuLink>
				<MenuLink to="/tags" disabled={ability.cannot('list', 'Member')} onDisabledClick={showNoListMembersPermCallout} data-testid="gear-menu-tags">
					{t('sections.memberTags')}
				</MenuLink>
				<MenuLink to="/deploy-groups" disabled={ability.cannot('list', 'Deployment/Group')} onDisabledClick={showNoListDeployGroupsPermCallout} data-testid="gear-menu-deploy-groups">
					{t('sections.deployGroups')}
				</MenuLink>
				<MenuLink to="/deploy-pipelines" disabled={ability.cannot('list', 'Deployment/Pipeline')} onDisabledClick={showNoListDeployPipelinesPermCallout}>
					{t('sections.deployPipelines')}
				</MenuLink>
				<MenuLink to="/oncall-schedule" disabled={ability.cannot('list', 'OnCallSchedule')} onDisabledClick={showNoListOnCallSchedulePermCallout} data-testid="gear-menu-oncall-schedule">
					{t('sections.onCallSchedule')}
				</MenuLink>
			</Menu>
			{missingListRolesPermCallout}
			{missingListUsersPermCallout}
			{missingListDeployGroupsPermCallout}
			{missingListMembersPermCallout}
			{missingListDeployPipelinesPermCallout}
			{missingListOnCallSchedulePermCallout}
		</>;
}